<template>
	<div v-loading.fullscreen.lock="searchLoading" element-loading-text="拼命加载中"
       style="position: absolute;
              padding-top: 10px;
              padding-bottom: 10px;
              height: 100%;
              width: 100%;
              background: #f5f5f5;
              top:0;
              left: 0;
              overflow-y: auto;">
<!--		<div class="title">-->
<!--      车信盟盟友号：CXM21CXX04-->
<!--		</div>-->

		<div class="content">
      <div style="font-size: 0">
        <div style="font-size: 10px; margin: 0 auto; color: #ffffff;
          background:linear-gradient(to right,#2582e7,#005CBF,#005CBF);
          border-top-left-radius: 5px; border-top-right-radius: 5px;">
          车信盟盟友号：CXM21CXX04
        </div>
        <div style="background-color: #005CBF; padding-top: 10px; padding-bottom: 10px; margin-top: -1px;
                  border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
          <img src="../assets/cxm_logo.png"
               style="max-width: 60%; height: 25px; display: block; margin:0 auto;">
        </div>
      </div>
      
			<el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" text-color="#000000" active-text-color="#0066ff">
				 <el-menu-item index="1" v-show="active1" class="el-menu-item" @click="active1Click">行驶证</el-menu-item>
         <el-menu-item index="1" v-show="!active1" class="el-menu-item" style="font-size: 19px;">行驶证</el-menu-item>
				 <el-menu-item index="2" v-show="active2" class="el-menu-item" @click="active2Click">注册登记证</el-menu-item>
         <el-menu-item index="2"  v-show="!active2" class="el-menu-item" style="font-size: 19px;">注册登记证</el-menu-item>
			</el-menu>

			<el-dialog class="eldialog" :visible.sync="fwxyOpen" title="服务协议" width="90%" :before-close="handleClose">
				车熙熙声明<br>
				欢迎您使用车熙熙，车熙熙是依托上海中经互联网络有限公司的信息资源建立的官方权威汽车信息服务平台-车信盟的合作平台（以下简称“平台“）。为了您更好的使用车熙熙，请详细阅读《车信报告查询服务协议》，认真遵守该协议是为您提供服务的前提。<br>
				车信报告查询服务协议<br>
				欢迎您通过“车熙熙”公众号查询车辆历史记录报告（“车信报告”包含但不限于车辆以“机动车销售统一发票”中“开票日期”为起始时间，由于其自身的技术特性、环境、人为、不可抗力等诸多因素所形成的具有可记录且不可变更的记录，具体内容以本公众号出最终出具的记录报告为准）。请确保您在使用车熙熙查询车辆历史记录报告之前已获得车辆所有人（即车主）授权或者同意，并且承诺不对任何第三方透露通过车熙熙所获得的任何信息。对于上述原因造成的所有不良后果，您需要承担一切法律责任及连带责任，与本平台无关。<br>
				一、【总则】<br>
				1.1 用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户与车熙熙平台达成协议，完全接受本协议项下的全部条款。<br>
				1.2 用户注册成功后，车熙熙将给予每个用户一个用户帐号，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。<br>
				1.3 用户一经注册车熙熙帐号，用户有权利用该账号使用该平台各项功能的单项服务，当用户使用平台各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及平台在该单项服务中发出的各类公告的同意。<br>
				1.4
				车熙熙服务协议以及各单项服务条款和公告可由平台随时更新，且无需另行通知。您在使用相关服务时,应关注并遵守其所适用的相关条款。您在使用车熙熙提供的各项服务之前，应仔细阅读本服务协议。如您不同意本服务协议及/或随时对其的修改，您可以主动取消车熙熙提供的服务；您一旦使用车熙熙服务，即视为您已了解并完全同意本服务协议各项内容，包括平台对服务协议随时所做的任何修改，并成为车熙熙用户。<br>
				二、【注册信息和隐私保护】<br>
				2.1
				车熙熙帐号的所有权归平台，用户完成注册申请手续后，获得车熙熙帐号的使用权。用户应提供及时、详尽及准确的资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，车熙熙不负任何责任。如果因注册信息不真实或更新不及时而引发的相关问题，车熙熙不负任何责任。<br>
				2.2
				用户应当通过真实身份信息认证注册账号，且用户提交的账号名称、头像等注册信息中不得出现违法和不良信息，经车熙熙审核，如存在上述情况，车熙熙将不予注册；同时，在注册后，如发现用户以虚假信息骗取账号名称注册，或其账号头像等注册信息存在违法和不良信息的，车熙熙有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。<br>
				2.3 用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生所有行为负全部责任。<br>
				2.4 车熙熙的隐私权保护声明（详见下方）说明了车熙熙如何收集和使用用户信息。您保证已经充分了解并同意车熙熙可以据此处理用户信息。<br>
				2.5 车熙熙可能会与合作伙伴共同向您提供您所要求的服务或者共同向您展示您可能感兴趣的内容。车熙熙会要求其确保数据安全并且禁止用于任何其他用途。除此之外，车熙熙不会向任何无关第三方提供或分享信息。<br>
				2.6 在如下情况下，车熙熙可能会披露您的信息：<br>
				（1）事先获得您的授权；<br>
				（2）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；<br>
				（3）以学术研究或公共利益为目的；<br>
				（4）为维护车熙熙的合法权益，例如查找、预防、处理欺诈或安全方面的问题；<br>
				（5）符合相关服务条款或使用协议的规定。<br>
				2.7 用户在注册账号后，必须对其设置的子账户管理负法律责任，子账户里的一切行为车熙熙视为用户的行为，车熙熙有权不经通知用户对子账户进行安全检查。<br>
				2.8 您知悉并授权，车熙熙仅在必需的情况下使用或与关联公司同步您的信息，以为用户提供相关服务。<br>
				2.9 为更好地向用户提供服务，您同意车熙熙通过短信等形式向您发送相关商业性服务信息。<br>
				三、【使用规则】<br>
				3.1 用户在使用车熙熙服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为
				（1）不得为任何非法目的而使用网络服务系统；<br>
				（2）不利用车熙熙服务从事以下活动：<br>
				1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；<br>
				2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br>
				3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br>
				4）故意制作、传播计算机病毒等破坏性程序的；<br>
				5）其他危害计算机信息网络安全的行为。<br>
				3.2
				用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿车熙熙与合作公司、关联公司，并使之免受损害。对此，车熙熙有权视用户的行为性质，采取包括但不限于暂停使用许可、终止服务、限制使用、回收车熙熙帐号、追究法律责任等措施。对恶意注册车熙熙帐号或利用车熙熙帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，车熙熙有权回收其帐号。同时，平台会视司法部门的要求，协助调查。<br>
				3.3
				对于你所查询的车辆信息必须通过车主本人同意或者授权，本人或者授权方式包括上传三证验证（即车辆产权证、行驶证和车主身份证）。用户未经车主同意或者授权，擅自查询车辆信息的，车熙熙将不承担任何法律责任。<br>
				3.4 用户不得对本服务任何部分或因本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。<br>
				3.5
				用户须对自己在使用车熙熙服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在本平台首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予本平台等额的赔偿。<br>
				四、【服务内容】<br>
				4.1 车熙熙网络服务的具体内容由车熙熙根据实际情况提供。<br>
				4.2 除非本服务协议另有其它明示规定，车熙熙所推出的新产品、新功能、新服务，均受到本服务协议之规范。<br>
				4.3
				为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。<br>
				4.4
				鉴于网络服务的特殊性，用户同意车熙熙有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。车熙熙不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。<br>
				4.5
				车熙熙需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，车熙熙无需为此承担任何责任。车熙熙保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。<br>
				4.6
				本服务或第三人可提供与其它国际互联网上之网站或资源之链接。由于车熙熙无法控制这些网站及资源，您了解并同意，此类网站或资源是否可供利用，车熙熙不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料，车熙熙亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，车熙熙不承担任何责任。<br>
				4.7
				用户明确同意其使用车熙熙网络服务所存在的风险将完全由其自己承担。用户理解并接受下载或通过车熙熙服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。车熙熙对在服务网上得到的任何商品购物服务、交易进程，都不作担保。<br>
				4.8 车熙熙有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，车熙熙对用户和任何第三人均无需承担任何责任。<br>
				4.9 终止服务<br>
				您同意车熙熙基于其自行之考虑，因任何理由，包含但不限于长时间（超过一年）未使用，或车熙熙认为您已经违反本服务协议的文字及精神，终止您的账户、密码或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，车熙熙可立即关闭或删除您的帐号、关联子账号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，车熙熙对您或任何第三人均不承担任何责任。<br>
				五、【其他】<br>
				5.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。<br>
				5.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向平台注册所在地的人民法院提起诉讼。<br>
				5.3 车熙熙未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。<br>
				5.4 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>
				请您在发现任何违反本服务协议以及其他任何单项服务的服务条款、车熙熙各类公告之情形时，通知车熙熙。您可以通过如下联络方式同车熙熙联系：<br>
				电子邮箱：custservice@carquery.cn<br>
				车熙熙隐私权保护声明<br>
				车熙熙非常重视用户信息的保护，在使用车熙熙的所有产品和服务前，请您务必仔细阅读并透彻理解本声明。一旦您选择使用，即表示您认可并接受本条款现有内容及其可能随时更新的内容。本隐私权保护声明适用于使用“车熙熙”移动设备应用程序的客户（以下简称“车熙熙”）和所有数据收集和使用通过车熙熙接口的网站。<br>
				一、【信息收集】<br>
				1.1
				您向车熙熙提供的信息。为了向您提供更好的用户服务,车熙熙会在您自愿选择服务或提供信息的情况下系统自动存储注册信息。请您在注册时及时、详尽及准确的提供个人资料，并不断更新注册资料。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，由您自行承担相应的后果。请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知车熙熙。互联网上不排除因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，此类情况与车熙熙无关。<br>
				二、【因您使用产品或服务获取的信息】<br>
				2.1 日志信息。当您使用车熙熙服务时，服务器会自动记录一些信息，例如您对我们服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言以及访问日期和时间等。<br>
				2.2
				设备信息。某些产品和/或服务包含唯一应用程序编号。当您安装、激活、更新、卸载相关服务或当这些服务定期与车熙熙通信（例如软件的更新）时，系统会将此编号以及与安装相关的信息（例如操作系统类型和应用程序版本号）发送给车熙熙。<br>
				当您使用具有定位功能的车熙熙服务时，系统会自动处理有关设备的位置信息，以使得您不需要手动输入自身地理坐标就可获得相关服务。<br>
				为了提供更好的服务与改善用户体验，车熙熙可能会记录硬件型号、操作系统版本号、国际移动设备身份码（IMEI）、网络设备硬件地址（MAC）等信息。<br>
				2.3 Cookie和匿名标识符等工具。Cookie主要的功能是便于您使用网站产品/或服务，以及帮助网站统计独立访客数量等。运用cookie技术，车熙熙平台能否为您提供更加周到的个性化服务。<br>
				当您使用平台产品或服务时，会向您的设备发送cookie。当您和我们提供给合作伙伴的服务（例如广告和/推广服务，以及可能显示在其他网站上的平台提供的服务功能）进行交互时，我们允许cookie或者匿名标识符发送给平台服务器。<br>
				2.4 以上数据信息都采用匿名的方式。同时，我们也会对信息采取加密处理，保证信息的安全性。<br>
				三、【信息使用】<br>
				3.1 车熙熙会以高度的勤勉义务对待这些信息，除非事先获得您的授权或本声明另有规定外，不会将这些信息对外公开或向第三方提供（车熙熙关联公司除外）。<br>
				3.2 车熙熙可能会与合作伙伴共同向您提供您所要求的服务或者共同向您展示您可能感兴趣的内容。车熙熙会要求其确保数据安全并且禁止用于任何其他用途。除此之外，车熙熙不会向任何无关第三方提供或分享信息。<br>
				3.3 车熙熙可能会对产品使用情况进行统计。同时，车熙熙可能会与公众分享这些统计信息，以展示我们服务的整体使用趋势。这些统计信息不包含您的任何身份识别信息。<br>
				3.4
				在如下情况下，车熙熙可能会披露您的信息：（1）事先获得您的授权；<br>（2）您使用共享功能；<br>（3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；<br>（4）以学术研究或公共利益为目的；<br>（5）为维护车熙熙的合法权益，例如查找、预防、处理欺诈或安全方面的问题；<br>（6）符合相关服务条款或使用协议的规定。<br>
				四、【信息安全】<br>
				4.1 车熙熙非常重视信息安全，应用多种安全技术和程序等措施，通过这些严格措施努力保护您的信息不被未经授权的访问、使用或泄漏。<br>
				五、【未成年人信息保护】<br>
				车熙熙非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，在使用车熙熙产品和/或服务前，应事先取得您的家长或法定监护人的同意。<br>
				六、【修订】<br>
				车熙熙随时会对本隐私权保护声明进行修订。<br>
				如果您还有其他问题和建议，请联系车熙熙。车熙熙会始终致力于充分保护用户信息，并为您提供更优质的体验和服务。<br>
				<el-button type="primary" class="register" @click="fwxyOpen = false">我已阅读</el-button>
			</el-dialog>

			<el-dialog class="eldialog" :visible.sync="bgsmOpen" title="报告说明" width="90%" :before-close="handleClose">
				1、车信报告（下称“本报告”）由上海中经互联网络有限公司旗下的车信盟（下称“本平台”）出具，本报告所包含车辆的内容及判断，仅基于截止到报告生成时系统中已经完成的信息整合、汇总、展示的相关信息。<br>
				2、本报告中的车辆仅限于在中国大陆地区合法注册登记的车辆，提供在中国大陆地区承保的历史车况查询。<br>
				3、本报告的信息依赖于第三方平台信息采集的准确性、及时性与完整性，故涉及车辆的某些信息有可能未被采集和收录或因为第三方平台信息的错误而存在错误，故本平台不保证信息的真实性、准确性和完整性。<br>
				4、本报告仅供查询方辅助参考作用，查询方在使用本报告时应自行甄别车辆的实际性能与状况，利用报告产生的法律后果或造成的任何侵权（包括自身疏忽）伤害，包括但不限于直接的、间接的、附带的、特殊的、惩罚性的、或类似的损害赔偿均由查询方/使用方自己承担责任。<br>
				5、本报告仅供查询方为合法目的而使用，禁止用于未经本平台允许的任何非正当或非法用途。<br>
				6、本报告仅供查询方按本平台的约定使用，请妥善保管本报告，因使用不当而引起纠纷的，本平台不承担相关责任。<br>
				<el-button type="primary" class="register" @click="bgsmOpen = false">我已阅读</el-button>
			</el-dialog>

<!--			<div style="margin-top: 20px;"></div>-->



			<div style="padding-top: 25px">
        <div class="line" v-show="show">
          <span style="color: #000000;">行驶证上传</span>
          <span style="color: red; font-size: 0.75rem; text-decoration:underline;"
                @click="shiliOpen">(原件正面拍摄上传示例)</span>
          <el-upload class="avatar-uploader" :action="this.$store.state.upload" :show-file-list="false"
                     accept="image/*"
                     :on-success="handleAvatarSuccess" :headers="headers" :before-upload="beforeAvatarUpload"
                     v-loading="loading">
            <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" v-model="ruleForm.imageUrl" class="avatar"
                 style="width: 100%;">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="height: 80px; margin-top: 21%;"></i>
          </el-upload>
        </div>
      </div>

      <div class="line" v-show="!show">
        <span style="color: #000000;">注册登记证上传</span>
        <span style="color: red; font-size: 0.75rem; text-decoration:underline;"
              @click="shiliOpen1">(原件正面拍摄上传示例)</span>
        <el-upload class="avatar-uploader" :action="this.$store.state.upload" :show-file-list="false"
                   accept="image/*"
                   :on-success="handleAvatarSuccess1" :headers="headers" :before-upload="beforeAvatarUpload"
                   v-loading="loading">
          <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" v-model="ruleForm.imageUrl" class="avatar"
               style="width: 100%;">
          <i v-else class="el-icon-plus avatar-uploader-icon" style="height: 80px; margin-top: 21%;"></i>
        </el-upload>
      </div>


    <div style="background-color: #ffffff; width: 95%; margin: 0 auto;">
      <div v-if="ruleForm.vin" @click="editVinOpen">
        <div
            style="height: 20px; width: 90%; margin-top: -10px; border-radius: 5%; font-size: 15px; background-color: #FFC107; margin: 0 auto; margin-top: 20px; text-align: center;">
          VIN码：<span style="color: #000000;"><b>{{ruleForm.vin}}</b></span> <i class="el-icon-edit"
                                                                               style="float: right; margin-right: 50px; margin-top: 2px;"></i>
        </div>
        </div>
      </div>
      <el-dialog title="VIN" :visible.sync="editVin" width="90%" :before-close="handleClose">
        <div style="display: flex; width: 100%;">
					<span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin0" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin1" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin2" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin3" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin4" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin5" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin6" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin7" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin8" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin9" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin10" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin11" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin12" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin13" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin14" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin15" maxlength="1" /></span>
          <span class="vin"><input @blur="changevin" :disabled="vinShow" @focus="End($event)" class="vinItem"
                                   type="text" v-model="vin16" maxlength="1" /></span>
        </div>
        <div style="margin-top: 15px; font-size: 12px;">若VIN号有误,请手动修改,最大支持修改三位,严禁恶意修改,一经发现将取消查询资格。</div>
        <span slot="footer" class="dialog-footer">
					<el-button @click="editVinClose" type="warning" style="color: #000000;">返 回</el-button>
					<el-button type="primary" @click="editVinSubmit">提交修改</el-button>
				</span>
      </el-dialog>

      <div class="bottom">
        <div>
          <el-checkbox v-model="check" class="el-checkbox" name="type" @click="checkStatus"></el-checkbox>
          <span style="color: #000000; font-size: 0.89rem;">
            &nbsp;我已阅读<span @click="fwxy()" class="a">《服务协议》</span>和<span @click="bgsm()"
                                                                                class="a">《报告说明》</span>
					</span>
        </div>

        <div @click="checkStatus2()" v-if="this.ownerLogic">
          <el-checkbox v-model="check2" class="el-checkbox" name="type" >
            <span style="color: #000000;">
              车主承诺：
              本人为该车辆所有权人，并同意将该车<br>辆进行交易为开展二手车交易授权。
            </span>
          </el-checkbox>
        </div>

        <div @click="checkStatus1()">
          <el-checkbox v-model="check1" class="el-checkbox" name="type" >
            <span style="color: #000000;">查询人承诺：我已获得车辆权利人同意我查询其<br>车辆相关信息之授权，</span>
            <span style="color: red;">
							我承诺车辆报告仅为车辆<br>评估交易之目的而妥善使用，如有违背，
							我将承<br>担所有责任，与车熙熙平台无关。
						</span>
          </el-checkbox>
        </div>

        <!--   新版     -->
        <div style="display: flex; height: 30px; width: 100%"
             v-for="item in searchInfo"
             :key="item.dictValue"
             v-if="searchInfo.length>0">
          <div style="padding: 5px 5px 5px 5px; border-radius: 50%;">
            <img src="../assets/hot.jpg"
                 style="display: block; margin:0 auto; width: 23px; height: 23px">
          </div>
         <div style="margin-top: -7px; margin-left: 2px; float: left;">
           <a :href="`report?img=${item.dictValue}&title=${item.remark}`" style="color: #ffffff; font-size: 0.95rem; background-color: #468cd9; height: 35px; border-radius: 5px;margin: 0px 0px 5px 0px" class="a">
             {{item.dictLabel}}
           </a>
         </div>
<!--          <div style="background-color: gainsboro; padding: 5px 5px 5px 5px; border-radius: 50%; margin-left: 15p%;">-->
<!--            <img src="../assets/logo.png"-->
<!--                 style="display: block; margin:0 auto; width: 20px; height: 18px">-->
<!--          </div>-->
        </div>


        <el-dialog title="查询承诺书" class="eldialog" :visible.sync="status" width="95%"
                   :before-close="handleClose">
          <el-card class="box-card" style="margin-top: -12%;">
            <div slot="header" class="clearfix" style="height: 20px; margin-top: -22px;">
              <span style="margin: 0 auto; color: #777777; font-size: 16px;">已获得车辆所有人售车意愿的承诺</span>
            </div>
            <div class="card_info">
              &nbsp;&nbsp;&nbsp;&nbsp;本人（姓名：<span class="red">{{ ruleForm.realName }}</span>　身份证号码：<span
                class="red">{{ ruleForm.idNumber }}</span>）已获得车辆所有人
              <input v-model="ruleForm.name" placeholder="" class="name"></input>
              明确将拟出售其名下车辆（车辆识别代码：<span
                class="red">{{ ruleForm.vin }}</span>）（同附件证件码），车辆所有人知晓本人持其行驶证至车信盟平台查询拟出售车辆的车辆信息。
            </div>
          </el-card>

          <el-card class="box-card">
            <div slot="header" class="clearfix" style="height: 20px; margin-top: -22px;">
              <span style="margin: 0 auto; color: #777777; font-size: 16px;">已取得查询拟出售车辆信息的授权承诺 </span>
            </div>
            <div class="card_info">
              &nbsp;&nbsp;&nbsp;&nbsp;本人保证在车辆所有人表达售车意愿后，已取得车辆所有人授权同意，为进
              行二手车交易或检测评估的目的将所收集的与拟出售车辆相关的信息（包括车架
              号、车辆行驶证信息等）提供于贵公司及贵公司的合作机构，贵公司及贵公司合
              作关系机构可基于二手车交易或检测评估的目的收集拟出售车辆相关信息（包括
              但不限于车辆的注册登记、保险及出险、维修保养信息等），并对上述信息进行
              处理后形成针对拟出售车辆情况的报告以协助开展二手车交易或检测评估有关事项。
              <br>
              <b>
                &nbsp;&nbsp;&nbsp;&nbsp;本人承诺：所提供的所有信息及承诺均真实、准确、完整、合法、有效，并
                保证上述全部内容均经过所有信息权利人充分、完全的认可同意。如果由于本人
                提供的信息或承诺不真实、不准确、不完整、不合法，本人承担由此所导致的后
                果和全部法律责任。
              </b>
            </div>

          </el-card>

          <el-card class="box-card">
            <div slot="header" class="clearfix" style="height: 20px; margin-top: -22px;">
              <span style="margin: 0 auto; color: #777777; font-size: 16px;">拟出售机动车登记证</span>
            </div>
            <img :src="ruleForm.imageUrl" style="width: 100%;">
          </el-card>
          <div style="float: right; ">
            <div @click="dialogVisible = true">
              查询人签名：
              <img :src="ruleForm.dzqm"
                   style="width: 100px; height: 30px; float: none; margin-bottom: 5px;">

              <i class="bi bi-pencil-square"></i>
            </div>
            日 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;期：&nbsp;&nbsp;&nbsp;{{ systemTime }}
          </div>

          <el-dialog :visible.sync="dialogVisible" title="查询人签名" width="90%" :before-close="handleClose"
                     v-loading="loading1">
            <div style="color: red; margin-top: -15%;">请点亮屏幕后签名</div>
            <dzqm @commit="commit"></dzqm>
          </el-dialog>

          <span slot="footer" class="dialog-footer" style="margin-right: 16%;">
						<el-button type="primary" class="register" @click="close">确 定</el-button>
					</span>
        </el-dialog>

        <el-dialog title="车主签名" class="eldialog" :visible.sync="ownerSign" width="95%"
                   :before-close="handleClose1">
          <el-card class="box-card" style="margin-top: -12%;">
            <div slot="header" class="clearfix" style="height: 20px; margin-top: -22px;">
              <span style="margin: 0 auto; color: #777777; font-size: 17px;">个人信息授权书</span>
            </div>
            <div class="card_info">
              致：车熙熙（以下简称“贵公司”）<br>
              &nbsp;&nbsp;&nbsp;&nbsp;本人承诺本人为该车辆所有权人，并同意将该车辆进行交易。为开展二手车
              交易，本人有权作出如下授权：<br>
              &nbsp;&nbsp;&nbsp;&nbsp;（1）本人同意贵公司可为进行二手车交易的目的将所收集的本人的个人信
              息（包括姓名、身份证件号等）和车辆信息（包括车架号、车辆行驶证等）提供
              给车信盟及车信盟合作机构。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;（2）本人同意车信盟及其合作机构可为协助贵公司开展二手车交易的目的
              使用上述信息，并基于此目的收集本人车辆的相关信息（包括但不限于车辆的注
              册登记、保险及出险、维修保养信息等），且车信盟及其合作机构可分别或共同
              对上述信息进行处理形成本人车辆的车况报告以便贵公司查询和评估，协助贵公
              司开展与本人的二手车交易有关事项。
              &nbsp;&nbsp;&nbsp;&nbsp;本授权书的授权期限为自本人签署之日起 90 天有效。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;本授权书是本人做出的单方承诺，效力具有独立性，不因本人与贵公司签订
              的相关合同解除、终止、被撤销、无效而丧失法律效力。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;本人承诺：在开展二手车交易过程中（包括交易前及交易后全过程）所提
              供的所有信息及承诺均真实、准确、完整、合法、有效，并保证上述全部授权
              内容均经过本人的充分、完全认可。
              <b>
                如果由于本人提供的信息或承诺不真实、
                不准确、不完整、不合法，本人承担由此所导致的后果和全部法律责任。<br>
              </b>
              <b>
                &nbsp;&nbsp;&nbsp;&nbsp;本人已经仔细阅读本授权书全部内容，对本授权书所有条款的含义及相应
                的法律后果已全部知晓并充分理解。
              </b>
            </div>

          </el-card>
          <div style="float: right; ">
            <div @click="dialogVisible1 = true">
              车主签名：
              <img :src="ruleForm.ownerSign"
                   style="width: 100px; height: 30px; float: none; margin-bottom: 5px;">

              <i class="bi bi-pencil-square"></i>
            </div>
            日 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;期：&nbsp;&nbsp;&nbsp;{{ systemTime }}
          </div>

          <el-dialog :visible.sync="dialogVisible1" title="车主签名" width="90%" :before-close="handleClose"
                     v-loading="loading1">
            <div style="color: red; margin-top: -15%;">请点亮屏幕后签名</div>
            <dzqm @commit="commit1"></dzqm>
          </el-dialog>

          <span slot="footer" class="dialog-footer" style="margin-right: 16%;">
						<el-button type="primary" class="register" @click="checkOwnerSign">确 定</el-button>
					</span>
        </el-dialog>
      </div>

      <el-dialog :visible.sync="ownerInfo" title="车主信息(例)" width="90%" :before-close="handleClose">
        <el-form ref="form" :model="ruleForm" label-width="80px">
          <el-form-item label="车主姓名">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="ruleForm.ownerIdCard"></el-input>
          </el-form-item>
          <div id="ownerSignDiv" v-show="false"><h1>{{ruleForm.name}}</h1></div>
          <el-button type="primary" @click="ownerInfoCheck" style="width: 100%">确 定</el-button>
        </el-form>
      </el-dialog>

      <el-dialog title="请输入密码" :visible.sync="searchPass" width="90%" :before-close="handleClose">
        <el-input placeholder="请输入六位数字密码" type="tel" style="-webkit-text-security: square" maxlength="6" minlength="6"
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.pass"></el-input>
        <div style="margin-top: 10px;" v-show="endSearch">
          <i class="el-icon-loading"></i><span style="color: red;"> 拼命生成报告中,请稍等...</span>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button @click="searchPass = false" type="warning" style="color: #000000;">取 消</el-button>
					<el-button type="primary" v-show="showYes" disabled>确 定</el-button>
					<el-button type="primary" v-show="!showYes" @click="passSearch">确 定</el-button>
				</span>
      </el-dialog>


      <el-dialog title="行驶证上传示例" :visible.sync="shili" width="90%" :before-close="handleClose">
        <img src="../assets/shili.jpg" style="width: 100%; height: 200px; border-radius: 10px;">
      </el-dialog>
      <el-dialog title="注册登记证上传示例" :visible.sync="shili1" width="90%" :before-close="handleClose">
        <img src="../assets/VehicleRegCertOCR1.jpg" style="width: 100%; height: 500px; border-radius: 10px;">
      </el-dialog>

      <el-dialog title="新用户提醒" :visible.sync="auth" width="90%" :before-close="authClose">
        <div>该功能仅限注册用户使用，一分钟快速完成注册！</div>
        <span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="toRegister">开 始</el-button>
					<el-button type="warning" style="color: #000000;" @click.stop="authClose">放 弃</el-button>
				</span>
      </el-dialog>


      <div style="display: flex">
        <el-button type="warning" size="small" class="recharge" @click="rechargePage">充 值</el-button>
        <el-button type="primary" size="small" v-if="this.isShowSearch()" class="register" @click="yesSearch()">查 询</el-button>
        <el-button type="primary" size="small" v-else class="register" v-loading="searchCheckLoding" disabled>查 询</el-button>
      </div>

      <div style="margin-top: -3%; float: right; margin-right: 6%; padding-bottom: 5%; font-size: 13px; color: #468cd9" @click="toOrder()">
        查看历史订单 >
      </div>


      <el-dialog
          title="重复查询提示"
          :visible.sync="checkRe"
          width="90%">
        <span style="color: red"><b>您24小时内查询过该车辆车信报告，是否再次查询</b></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelSearch" type="primary">查看报告</el-button>
          <el-button @click="twoSearch" type="danger">再次查询</el-button>
        </span>
      </el-dialog>

      <el-dialog
          title="查询提示"
          :visible.sync="doMaintenanceOrderDi"
          width="90%">
        <span style="color: red"><b>本次查询车信及维保次数都会-1，但同时您将获得车信报告及维保两份报告，是否确定查询？</b></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="this.doMaintenanceOrderDi = false" type="primary">取消</el-button>
          <el-button @click="twoSearch" type="danger">确定查询</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
	import plateNumber from './plateNumber'
	import dzqm from './dzqm.vue'
  import html2canvas from "html2canvas";
	export default {
		components: {
			dzqm,
			plateNumber
		},

		data() {
			return {
        active1:false,
        active2:true,
        authentication:'',
        auth:false,
				editVin: false,
        searchType: 1,
				showBtn: true,
				showYes: false,
				loading: false,
				searchLoading: false,
				loading1: false,
        searchCheckLoding:false,
				searchPass: false,
				fwxyOpen: false,
				bgsmOpen: false,
				shili: false,
        shili1: false,
				endSearch: false,
        checkRe: false,//当天重复查询的提醒
        orderRe: '',//重复订单返回的链接
				visible: false, //最后查询的确认
				check: false, //复选框
				check1: false, //第二个复选框
        check2: false, //车主签名
        ownerInfo: false, //车主信息表单
        ownerSign: false,
				status: false, //承诺书窗口
				dialogVisible: false, //电子签名页面
        dialogVisible1: false, //电子签名页面
				show: true, //是否显示车牌号输入框
				activeIndex: '1',
				activeName: 'second',
				headers:{"openId":localStorage.getItem('openId'),"thirdsession":this.$Cookies.get('thirdsession')},
				picFile: '',
				upfile: {},
				systemTime: '',
				imageUrl: '',
        ownerLogic: false,
				// ruleForm: {
        //   autoSignImg: false,
				// 	imageUrl: 'https://s1.carquery.cn/2023-08-17/8c5b34b0-2e6a-4822-8b20-f1ab4dbfd2d0.jpg',
        //   ownerSign: 'https://s1.carquery.cn/2023-08-17/a9dfc9b0-c89d-405f-9bfa-16a48bfa72f3.png',
        //   ownerIdCard: '410622200112103033',
				// 	phone: '',
				// 	name: '贾振华',
				// 	realName: '贾振华',
				// 	idNumber: 'X1062220011210303X',
				// 	dzqm: 'https://s1.carquery.cn/2023-08-17/cf4ac159-cf33-46e9-a117-5a4a07bc9acc.png',
				// 	vin: 'LFV2A2158G3102174',
				// 	pass: '',
				// 	openId: '',
				// 	carcode: 'LFV2A2158G3102174',
				// },
        ruleForm: {
          imageUrl: '',
          ownerSign: '',
          ownerIdCard: '',
          phone: '',
          name: '',
          realName: '',
          idNumber: '',
          dzqm: '',
          vin: '',
          pass: '',
          openId: '',
          carcode: '',
        },
				initPass: '', //加密前的密码
				vin0: '',
				vin1: '',
				vin2: '',
				vin3: '',
				vin4: '',
				vin5: '',
				vin6: '',
				vin7: '',
				vin8: '',
				vin9: '',
				vin10: '',
				vin11: '',
				vin12: '',
				vin13: '',
				vin14: '',
				vin15: '',
				vin16: '',
				changeVin: 0,
				vinShow: false,

				imgurl: '',
        userPassword:null,
        isFreeze:'',
        status1:'',
        searchInfo:[],
        doMaintenanceOrderTips: '',
        doMaintenanceOrderDi: false,
			};
		},
		computed: {
			plate_license_1() {
				return (
					this.vin0 +
					this.vin1 +
					this.vin2 +
					this.vin3 +
					this.vin4 +
					this.vin5 +
					this.vin6 +
					this.vin7 +
					this.vin8 +
					this.vin9 +
					this.vin10 +
					this.vin11 +
					this.vin12 +
					this.vin13 +
					this.vin14 +
					this.vin15 +
					this.vin16
				)
			},
		},
		methods: {
      toOrder(){
        this.$router.push("/order")
      },
      authClose(){
        this.check1=false
        this.auth = false
      },
      toRegister(){
        this.$router.push("/registerHome")
      },
      rechargePage(){
        if (this.authentication != 4){
          this.auth = true
        }else{
          this.$router.push('/recharge?openId=' + this.ruleForm.openId + "&remark=报告")
        }
      },
      active2Click(){
        this.check = false
        this.check1 = false
        this.active2 = false
        this.active1 = true
      },
      active1Click(){
        this.check = false
        this.check1 = false
        this.active2 = true
        this.active1 = false
      },
			shiliOpen() {
        if(this.authentication!=4){
          this.shili = false
        }else{
          this.shili = true
        }

			},
      shiliOpen1() {
        if(this.authentication!=4){
          this.shili1 = false
        }else{
          this.shili1 = true
        }
      },
			editVinClose() {
				this.editVin = false
				this.changeVin = 0
				this.vinShow = false
			},
      cancelSearch(){
        this.searchPass = false
        this.checkRe = false
        this.searchLoading = true
        this.$router.push("/openOrder?orderno=" + this.orderRe + "&ordertype=1")
      },
      twoSearch(){
        this.checkRe = false
        this.searchPass = false
        this.searchLoading = true
        this.$api({
          method: 'post',
          url: '/mobileLogin/doRepeatOrderWithOrderno',
          params: {
            vin: this.ruleForm.vin,
            autograph: this.ruleForm.dzqm,
            driving_license: this.ruleForm.imageUrl,
            openId: this.ruleForm.openId,
            ownerSign: this.ruleForm.ownerSign,
            password: this.ruleForm.pass,
            carcode: this.ruleForm.carcode,
            owner: this.ruleForm.name,
            searchType: 1
          }
        }).then(res => {
          if(res.data.code == 200){
            this.$router.push("/openOrder?orderno=" + res.data.data.orderno + "&ordertype=" + res.data.data.ordertype + "&vin=" + res.data.data.vin)
          }else{
            this.$notify.info({
              title: res.data.msg,
              showClose: false,
              duration: 4000
            });
            this.ruleForm.pass = ''
            this.searchLoading = false
            this.endSearch = false
            this.showYes = false
          }
        })
      },
      ownerInfoCheck: function () {
        if (this.ruleForm.ownerIdCard != '' && this.ruleForm.name != '') {
          //this.drawLogo(this.ruleForm.name)
          this.ownerInfo = false
          this.ownerSign = true
          this.check2 = false
        } else {
          this.$notify.info({
            title: '车主信息不完整',
            showClose: false,
            duration: 5000
          });
        }
      },
      drawLogo(text, font) {
        // 创建画布
        let canvas = document.createElement('canvas');
        // 绘制文字环境
        let context = canvas.getContext('2d');
        // 设置字体
        context.font = font;
        // 获取字体宽度
        let width = context.measureText(text).width;
        // 如果宽度不够 240
        if (width < 180) {
          width = 180;
        } else {
          width = width + 30;
        }
        // 画布宽度
        canvas.width = width;
        // 画布高度
        canvas.height = 60;
        // 填充白色
        context.fillStyle = '#ffffff';
        // 绘制文字之前填充白色
        context.fillRect(0, 0, canvas.width, canvas.height);
        // 设置字体
        context.font =  "35px " + font;
        // 设置水平对齐方式
        context.textAlign = 'center';
        // 设置垂直对齐方式
        context.textBaseline = 'middle';
        // 设置文字颜色
        context.fillStyle = 'black';
        // 绘制文字(参数：要写的字，x坐标，y坐标)
        context.fillText(text, canvas.width / 2, canvas.height / 2);
        // 生成图片信息
        let dataUrl = canvas.toDataURL('image/png');
        this.commit1(dataUrl)
        console.log("dataUrl: ="  +dataUrl)
      },
			yesSearch() {
        if (this.authentication != 4){
          this.auth = true
        }else{
          if (this.check == true && this.check1 == true) {
            this.$api({
              methods: 'get',
              url: '/mobileLogin/getInfoByOpenId?openId=' + this.openId,
            }).then((res) => {
              //不是空就打开密码窗口
              if(res.data.password!=null && res.data.password!=''){
                this.searchPass = true
              }else{
                this.searchLoading = true
                this.doOrder()
              }
            })
          }else{
            this.$notify.info({
              title: '请先勾选上述条件',
              showClose: false,
              duration: 5000
            });
          }
        }
			},

      passSearch(){
        if (this.ruleForm.pass.length < 6 && this.ruleForm.pass!=null && this.ruleForm.pass!='') {
          this.$notify.info({
            title: '请输入六位数字密码',
            showClose: false,
            duration: 5000
          });
        } else {
          this.endSearch = true
          this.showYes = true
          if(this.searchType == 1){
            this.doOrder()
          }else if(this.searchType == 2){
            this.doMaintenanceOrder()
          }
        }
      },

      doOrder(){
        this.$api({
          method: 'post',
          url: '/mobileLogin/doOrderWithOrderno',
          params: {
            vin: this.ruleForm.vin,
            autograph: this.ruleForm.dzqm,
            driving_license: this.ruleForm.imageUrl,
            openId: this.ruleForm.openId,
            ownerSign: this.ruleForm.ownerSign,
            password: this.ruleForm.pass,
            carcode: this.ruleForm.carcode,
            owner: this.ruleForm.name,
            ownerIdCard: this.ruleForm.ownerIdCard
          }
        }).then(res => {
          if(res.data.code == 200){
            this.$router.push("/openOrder?orderno=" + res.data.data.orderno + "&ordertype=" + res.data.data.ordertype + "&vin=" + res.data.data.vin)
          }else{
            if(JSON.stringify(res.data.msg).slice(0, 5) == '"重复订单'){
              this.searchPass = false
              this.checkRe = true
              //这个就是orderno订单号
              this.orderRe = JSON.stringify(res.data.msg).slice(6,-1)
            }else{
              this.$notify.info({
                title: res.data.msg,
                showClose: false,
                duration: 4000
              });
            }

            this.searchCheckLoding = false
            this.showBtn = false

            this.ruleForm.pass = ''
            this.searchLoading = false
            this.endSearch = false
            this.showYes = false
          }
        })
      },
      doMaintenanceOrder(){
        this.$api({
          method: 'post',
          url: '/mobileLogin/doMaintenanceOrder',
          params: {
            vin: this.ruleForm.vin,
            autograph: this.ruleForm.dzqm,
            driving_license: this.ruleForm.imageUrl,
            openId: this.ruleForm.openId,
            password: this.ruleForm.pass,
            carcode: this.ruleForm.carcode,
            owner: this.ruleForm.name
          }
        }).then(res => {
          if(JSON.stringify(res.data).slice(0, 5) == '"重复订单'){
            this.searchPass = false
            this.checkRe = true
            this.orderRe = JSON.stringify(res.data).slice(6,-1)
          }

          let str = JSON.stringify(res.data.slice(0,6))
          if(str.includes("账户余额不足")){
            this.$notify.info({
              title: res.data,
              showClose: false,
              duration: 4000
            });
          }


          if(res.data == "查询该车辆维保需要先查询车信报告"){
            this.doMaintenanceOrderTips = "查询该车辆维保需要先查询车信报告"
            this.doMaintenanceOrderDi = true
          }

          let http = JSON.stringify(res.data).split(':')
          if (http[http.length - 2] == '"https') {
            window.location.replace(res.data)
          }else {
            if(JSON.stringify(res.data).slice(0, 5) == '"重复订单'){

            }else{
              this.$notify.info({
                title: res.data,
                showClose: false,
                duration: 4000
              });
              this.searchCheckLoding = false
              this.showBtn = false
            }
            this.ruleForm.pass = ''
            this.searchLoading = false
            this.endSearch = false
            this.showYes = false
          }
        })
      },


      getSearchInfo() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/searchInfo?dictType=' + "cxx_search_info"
        }).then(res => {
          if(res.data.data.length>0){
            this.searchInfo = res.data.data
          }
        })
      },

      isOwnerSignLogic() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/searchInfo?dictType=' + "cxx_owner_logic"
        }).then(res => {
          if(res.data.data.length>0){
            if(res.data.data[0].dictValue === '1'){
              this.ownerLogic = true
            }else{
              this.ownerLogic = false
            }
          }
        })
      },


      changevin() {
				if (this.changeVin + 1 < 3) {
					this.changeVin++
				} else {
					this.vinShow = true
				}
			},
			editVinSubmit() {
				this.ruleForm.vin = this.plate_license_1
				this.editVin = false
			},

			End(e) { //input获取光标显示在最后
				let obj = e.srcElement;
				obj.focus();
				const len = obj.value.length;
				//光标定位要加上 setTimeOut，不然就会重新光标定位失败
				setTimeout(() => {
					obj.selectionStart = obj.selectionEnd = len;
				}, 60)
			},
			editVinOpen() {
				this.editVin = true
				this.vin0 = this.ruleForm.vin[0]
				this.vin1 = this.ruleForm.vin[1]
				this.vin2 = this.ruleForm.vin[2]
				this.vin3 = this.ruleForm.vin[3]
				this.vin4 = this.ruleForm.vin[4]
				this.vin5 = this.ruleForm.vin[5]
				this.vin6 = this.ruleForm.vin[6]
				this.vin7 = this.ruleForm.vin[7]
				this.vin8 = this.ruleForm.vin[8]
				this.vin9 = this.ruleForm.vin[9]
				this.vin10 = this.ruleForm.vin[10]
				this.vin11 = this.ruleForm.vin[11]
				this.vin12 = this.ruleForm.vin[12]
				this.vin13 = this.ruleForm.vin[13]
				this.vin14 = this.ruleForm.vin[14]
				this.vin15 = this.ruleForm.vin[15]
				this.vin16 = this.ruleForm.vin[16]
			},
			// open(formName) {
			// 	if (this.check == true && this.check1 == true) {

			// 	} else {
			// 		this.$notify.info({
			// 		  title: '请先勾选上述条件',
			// 		  showClose: false,
			// 		  duration: 5000
			// 		});
			// 	}

			// },
			commit(imageUrl) {
				//this.loading1 = true
				let img = encodeURIComponent(imageUrl)
				this.$api({
					method: 'post',
					url: '/mobileLogin/uploadImgBase64?openId=' + this.ruleForm.openId + '&upfile=' + img
				}).then(res => {
					if (res.data.state == 'SUCESS') {
            this.ruleForm.dzqm = this.$store.state.showUpload + res.data.url
						this.dialogVisible = false
					} else if (res.data.state == 'ERROR') {
						this.$notify.info({
							title: '服务器开小差了，请重新签名',
							showClose: false,
							duration: 5000
						});
					}
				})
			},
      commit1(imageUrl) {
        let img = encodeURIComponent(imageUrl)
        this.$api({
          method: 'post',
          url: '/mobileLogin/uploadImgBase?openId=' + this.ruleForm.openId + '&upfile=' + img
        }).then(res => {
          this.ruleForm.ownerSign = this.$store.state.showUpload + res.data.url
          this.dialogVisible1 = false
        })
      },
			handleClose(done) {
        this.check1 = false
				this.check2 = false
				done();
			},
      handleClose1(){
        this.ownerSign = false
      },
			handleSelect(key, keyPath) {
				if (key == 1) {
					this.ruleForm.imageUrl = '',
						this.ruleForm.phone = '',
						this.ruleForm.dzqm = '',
						this.ruleForm.vin = '',
						this.show = true;
				} else if (key == 2) {
					this.ruleForm.imageUrl = '',
						this.ruleForm.phone = '',
						this.ruleForm.dzqm = '',
						this.ruleForm.vin = '',
						this.show = false;
				}
			},
			fwxy() {
        this.fwxyOpen = true
			},
			bgsm() {
        this.bgsmOpen = true
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.imageUrl = this.$store.state.showUpload + res.url
				this.imgurl = res.url
				this.$api({
					method: 'post',
					url: '/mobileLogin/ocr',
					params: {
						openId: this.ruleForm.openId,
						img: this.ruleForm.imageUrl
					}
				}).then((res) => {
					if (res.data.code == 200) {
						this.ruleForm.vin = res.data.data.vin
						this.ruleForm.name = res.data.data.owner
						this.ruleForm.carcode = res.data.data.plateNo

						this.vin0 = this.ruleForm.vin[0]
						this.vin1 = this.ruleForm.vin[1]
						this.vin2 = this.ruleForm.vin[2]
						this.vin3 = this.ruleForm.vin[3]
						this.vin4 = this.ruleForm.vin[4]
						this.vin5 = this.ruleForm.vin[5]
						this.vin6 = this.ruleForm.vin[6]
						this.vin7 = this.ruleForm.vin[7]
						this.vin8 = this.ruleForm.vin[8]
						this.vin9 = this.ruleForm.vin[9]
						this.vin10 = this.ruleForm.vin[10]
						this.vin11 = this.ruleForm.vin[11]
						this.vin12 = this.ruleForm.vin[12]
						this.vin13 = this.ruleForm.vin[13]
						this.vin14 = this.ruleForm.vin[14]
						this.vin15 = this.ruleForm.vin[15]
						this.vin16 = this.ruleForm.vin[16]
					} else if (res.data.code == 500) {
						this.ruleForm.imageUrl = ''
						this.$notify.info({
							title: res.data.msg,
							showClose: false,
							duration: 5000
						});
					}
				})

				this.loading = false
			},

      handleAvatarSuccess1(res, file) {
        this.ruleForm.imageUrl = this.$store.state.showUpload + res.url
        this.imgurl = res.url
        this.$api({
          method: 'post',
          url: '/mobileLogin/ocr1',
          params: {
            openId: this.ruleForm.openId,
            img: this.ruleForm.imageUrl
          }
        }).then((res) => {
          if (res.data.code == 200) {
            this.ruleForm.vin = res.data.data.vin
            this.ruleForm.name = res.data.data.owner
            this.ruleForm.carcode = res.data.data.plateNo

            this.vin0 = this.ruleForm.vin[0]
            this.vin1 = this.ruleForm.vin[1]
            this.vin2 = this.ruleForm.vin[2]
            this.vin3 = this.ruleForm.vin[3]
            this.vin4 = this.ruleForm.vin[4]
            this.vin5 = this.ruleForm.vin[5]
            this.vin6 = this.ruleForm.vin[6]
            this.vin7 = this.ruleForm.vin[7]
            this.vin8 = this.ruleForm.vin[8]
            this.vin9 = this.ruleForm.vin[9]
            this.vin10 = this.ruleForm.vin[10]
            this.vin11 = this.ruleForm.vin[11]
            this.vin12 = this.ruleForm.vin[12]
            this.vin13 = this.ruleForm.vin[13]
            this.vin14 = this.ruleForm.vin[14]
            this.vin15 = this.ruleForm.vin[15]
            this.vin16 = this.ruleForm.vin[16]
          } else if (res.data.code == 500) {
            this.ruleForm.imageUrl = ''
            this.$notify.info({
              title: res.data.msg,
              showClose: false,
              duration: 5000
            });
          }
        })

        this.loading = false
      },


			beforeAvatarUpload(file) {
				const isLt30M = file.size / 1024 / 1024 < 30;
				if (!isLt30M) {
					this.$message.error('上传图片大小不能超过 30MB!');
					this.loading = false
				} else {
					this.loading = true
					return isLt30M;
				}

			},

			checkStatus() {
        if(this.check = true && this.authentication!=4){
          // IE
          if (document.all) {
            document.getElementById(clickId).click();
          }
          // 其它浏览器
          else {
            var e = document.createEvent("MouseEvents");
            e.initEvent("click", true, true);
            document.getElementById(clickId).dispatchEvent(e);
          }
        }else if(this.check = true && this.authentication==4){
          this.check == true ? false : true
        }

			},
      getUserInfo(){
        this.$api({
          methods: 'get',
          url: '/mobileLogin/getInfoByOpenId?openId=' + this.ruleForm.openId
        }).then((res) => {
          this.ruleForm.realName = res.data.realName
          this.ruleForm.idNumber = res.data.idNumber
          this.ruleForm.ownerIdCard = res.data.idNumber
          this.ruleForm.dzqm = res.data.signUrl
          this.userPassword = res.data.password

          //生产
          if (this.ruleForm.vin != '' && this.ruleForm.imageUrl != '') {

          } else {
            this.check1 = false
            this.$notify.info({
              title: '请检查你的信息是否完善',
              showClose: false,
              duration: 5000
            });
          }
        })
      },
			checkStatus1() {
        this.addDate()
        if(this.authentication!=4) {
          this.auth = true
        }else{
          this.getUserInfo()
          this.status = true
        }
			},
      checkStatus2() {
        this.getUserInfo()
        this.addDate()
        if(this.authentication!=4) {
          this.auth = true
        }else{
          this.ownerInfo = true
        }
      },
      // close1(){
      //   this.check2 = false
      // },
      checkOwnerSign(){
        if (this.ruleForm.ownerSign == ''){
          this.$notify.info({
            title: '请车主签名在授权书下方签名',
            showClose: false,
            duration: 5000
          });
        }else{
          this.check2 = true
          this.ownerSign = false
          this.isShowSearch()
        }
      },
      isShowSearch(){
        if(this.ownerLogic){
          //开启车主签名逻辑
          if(this.check && this.check1 && this.check2){
            return true
          }else{
            return false
          }
        }else{
          //关闭车主签名逻辑
          if(this.check && this.check1){
            return true
          }else{
            return false
          }
        }

      },
			close() {
				if (this.ruleForm.name != '' && this.ruleForm.name != null && this.ruleForm.dzqm != '') {
					this.check1 = true
					this.status = false
          this.isShowSearch()
				} else {
					this.check1 = false
					this.$notify.info({
						title: '请检查你的信息是否完善',
						showClose: false,
						duration: 5000
					});
				}
			},

			addDate() {
				let nowDate = new Date()
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate()
				}
				this.systemTime = date.year + ' - ' + date.month + ' - ' + date.date
			}

		},
    getInfoByOpenId() {
      this.$api({
        methods: 'get',
        url: '/mobileLogin/getInfoByOpenId?openId=' + this.openId,
      }).then((res) => {
        this.isFreeze = res.data.isFreeze
        if (this.isFreeze == 1) {
          this.$router.push('/error?text=该账号已被冻结')
        }
      })
    },


    beforeCreate() {
      this.openId = this.$route.query.openid
    },
    destroyed() {
			this.searchLoading = false
		},
    created() {
      localStorage.setItem("status", this.$route.query.status)
      localStorage.setItem("openId", this.$route.query.openid)
      localStorage.setItem("userId", this.$route.query.userId)

      this.openId = localStorage.getItem("openId")
      this.$store.state.openId = localStorage.getItem("openId")
      this.ruleForm.openId = localStorage.getItem("openId")
      this.authentication = localStorage.getItem("status")
      this.status1 = localStorage.getItem("status")

      this.getSearchInfo()
      this.isOwnerSignLogic()
      if (this.status1 != 0 && this.status1 != 1 && this.status1 != 2 && this.status1 != 3 && this.status1 != 4) {
        this.$router.push('/error?text=该账号已被冻结')
      }
      this.getInfoByOpenId()
    },

	}
</script>

<style scoped="scoped">
	.eldialog {
		margin-top: -20%;
	}

	.vin {
		margin-left: 2px;
		size: 5px;
		border-bottom: 0.0625rem solid #00F7DE;
		text-align: center;
	}

  .vinItem {
    text-align: center;
    width: 110%;
    /* 这个很重要，解决ios不居中的问题 */
    padding-right: 1.6px;
    border: none;
  }

	.vinItem1 {
		text-align: center;
    background-color: #ffffff;
		width: 100%;
		/* 这个很重要，解决ios不居中的问题 */
		padding-right: 1.6px;
		border: none;
	}

	.cph {
		width: 50%;
		margin-left: 25%;
		margin-bottom: 3%;
	}

	.plateNumber {
		margin-bottom: -10%;
	}

	.content {
		width: 95%;
		margin: 0 auto;
    padding-bottom: 5%;
		background-color: #FFFFFF;
	}

	.el-menu-item {
		text-align: center;
		font-size: 16px;
    color: #ffffff;
		width: 50%;
		font-weight: 700;
	}

	.line {
		text-align: center;
		background-color: #f5f5f5;
		width: 90%;
		border-radius: 3%;
		margin: 0 auto;
	}

	.el-checkbox {
		color: #000000;
	}

	.register {
		width: 60%;
		margin-left: 5%;
		margin-top: 20px;
		margin-bottom: 20px;
	}

  .recharge{
    width: 25%;
    margin-left: 5%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

	.bottom {color: #000000;
		line-height: 3.125rem;
		width: 90%;
		margin: 0 auto;
		word-break: normal;
	}

	.a {
		color: #005CBF;
		/* text-decoration: none; */
		text-decoration: underline
	}

	.box-card {
		margin-bottom: 20px;
	}

	.card_info {
		line-height: 20px;
		width: 95%;
	}

	.name {
		width: 35%;
		border: none;
		color: red;
		text-align: center;
		border-bottom: 1px solid #000
	}

	.red {
		color: red;
	}

	a {
		text-decoration: blink;
	}

  >>> .el-checkbox__label{
    color: #585656;
  }
</style>
